import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { articles, getCategoryBySlug } from "@/mocks/articles";
import { Link } from "react-router-dom";

export default function FeatureSection() {
  const heroSlug = (articles.find((item) => item.featured) ?? articles[0]).slug;
  const rest = articles.filter((item) => item.slug !== heroSlug);
  const lead = rest[0];
  const sideList = rest.slice(1, 6);

  return (
    <section className="mx-auto max-w-editorial px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="编辑精选"
        title="本周值得完整读完的复盘"
        desc="挑选那些把来龙去脉讲清楚的长文，适合安静地坐下来读。"
        action={{ label: "查看全部", href: "/insights" }}
      />

      <div className="mt-9 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
        <div className="fade-up lg:col-span-8">
          <ArticleCard article={lead} variant="large" />
          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <i className="ri-bookmark-3-line" aria-hidden="true"></i>
              核心结论
            </p>
            <ul className="mt-3 space-y-2.5">
              {lead.keyPoints.map((point) => (
                <li key={point} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" aria-hidden="true"></span>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <aside className="fade-up fade-up-1 lg:col-span-4" aria-label="热读榜单">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-center justify-between border-b border-background-200 pb-4">
              <h3 className="font-heading text-lg font-bold text-foreground-950">热读榜</h3>
              <span className="text-xs text-foreground-500">近 7 天</span>
            </div>
            <ul className="mt-1">
              {sideList.map((item, index) => (
                <li key={item.slug} className="group flex gap-3 border-b border-background-200 py-4 last:border-b-0 last:pb-0">
                  <span
                    className={`font-heading text-lg font-bold leading-none ${
                      index < 3 ? "text-primary-500" : "text-foreground-300"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0">
                    <h4 className="font-heading text-sm font-semibold leading-snug text-foreground-900">
                      <Link to={`/insights/${item.slug}`} className="transition-colors group-hover:text-primary-600">
                        {item.title}
                      </Link>
                    </h4>
                    <p className="mt-1.5 text-xs text-foreground-500">
                      {getCategoryBySlug(item.categorySlug)?.name} · {item.readMinutes} 分钟
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-5 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-secondary-700">
              <i className="ri-shield-check-line" aria-hidden="true"></i>
              我们的写法
            </p>
            <p className="mt-2.5 text-sm leading-relaxed text-secondary-900/85">
              只引用可查证的公开信息，明确区分事实、推测与待确认说法，不替读者下结论。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}